module.exports = __webpack_public_path__ + "img/sys3.74cff31a.png";